import { Controller } from "stimulus"
var jQuery = require("jquery");

global.$ = global.jQuery = jQuery;
window.$ = window.jquery = jQuery;
const trkDatatables = require("trk_datatables")

const DEFAULT_TAB_HREFS = ["#tab15-activity-logs", "#tab15-error-logs"]

function debounce(fn, ms) {
  let t
  return function (...args) {
    window.clearTimeout(t)
    t = window.setTimeout(() => fn.apply(this, args), ms)
  }
}

export default class extends Controller {
  connect() {
    const raw = this.element.dataset.tabHrefs
    this._tabHrefs = raw ? JSON.parse(raw) : DEFAULT_TAB_HREFS
    this._parentHref = this.element.dataset.parentHref || null

    this.savedSearch = {}
    this._timeoutId = window.setTimeout(() => {
      const pane = this.element.querySelector(".tab-pane.active")
      if (pane && this._tabHrefs.indexOf("#" + pane.id) !== -1) this.activatePane(pane)
    }, 150)

    this._onTabShown = (e) => {
      const href = e.target && e.target.getAttribute("href")
      if (!href) return

      if (this._tabHrefs.indexOf(href) !== -1) {
        const pane = this.element.querySelector(href)
        if (pane) window.requestAnimationFrame(() => this.activatePane(pane))
        return
      }

      // When parent tab becomes visible, re-activate the current active inner pane
      if (this._parentHref && href === this._parentHref) {
        const activePane = this.element.querySelector(".tab-pane.active")
        if (activePane && this._tabHrefs.indexOf("#" + activePane.id) !== -1) {
          window.requestAnimationFrame(() => this.activatePane(activePane))
        }
      }
    }
    document.addEventListener("shown.bs.tab", this._onTabShown)
  }

  disconnect() {
    if (this._timeoutId) window.clearTimeout(this._timeoutId)
    document.removeEventListener("shown.bs.tab", this._onTabShown)
    this._tabHrefs.forEach((h) => {
      const p = this.element.querySelector(h)
      this.stripTable(p && p.querySelector("table"))
    })
  }

  trkInitOptions() {
    return {
      lengthMenu: [10, 20, 50, 100],
      scrollX: false,
      pagingType: "simple",
      oLanguage: {
        search: "",
        searchPlaceholder: "Search...",
        info: "Showing _START_ to _END_ of _TOTAL_ entries",
        lengthMenu: "Show entries _MENU_",
        infoFiltered: "",
        paginate: {
          next: '<i class="fa fa-angle-right">',
          previous: '<i class="fa fa-angle-left">',
        },
      },
      dom: '<"trk-global-search-wrapper"f>rtp<"trk-move-up"li>',
    }
  }

  stripTable(table) {
    if (!table) return
    const el = table
    try {
      if ($.fn.DataTable.isDataTable(el)) {
        $(el).DataTable().destroy(false)
      }
    } catch (err) {
      console.warn("display-logs-tabs-datatable: destroy failed", err)
    }
    $(el).removeClass("dataTable no-footer")

    const wrap = el.closest(".dataTables_wrapper")
    if (wrap && wrap.parentNode) {
      wrap.parentNode.insertBefore(el, wrap)
      wrap.remove()
    }
    el.removeAttribute("data-datatable")
  }

  enableDatatable(table) {
    if (!table) return
    table.setAttribute("data-datatable", "true")
  }

  saveSearchesFromLiveTables() {
    this._tabHrefs.forEach((h) => {
      const p = this.element.querySelector(h)
      const tbl = p && p.querySelector("table")
      if (tbl && $.fn.DataTable.isDataTable(tbl)) this.savedSearch[h] = $(tbl).DataTable().search()
    })
  }

  wireSearch(tableEl) {
    if (!tableEl || !$.fn.DataTable.isDataTable(tableEl)) return
    const api = $(tableEl).DataTable()
    const $inp = $(api.table().container()).find(".dataTables_filter input").first()
    if (!$inp.length) return
    const run = debounce((val) => {
      api.search(val).draw()
    }, 350)
    $inp.off("input").on("input", function () {
      run(this.value)
    })
  }

  activatePane(pane) {
    if (!pane) return
    const href = "#" + pane.id
    if (this._tabHrefs.indexOf(href) === -1) return

    this.saveSearchesFromLiveTables()

    this._tabHrefs.forEach((h) => {
      const p = this.element.querySelector(h)
      this.stripTable(p && p.querySelector("table"))
    })

    const activeTable = pane.querySelector("table")
    if (!activeTable) return

    this.enableDatatable(activeTable)

    try {
      trkDatatables.initialise(this.trkInitOptions())
    } catch (err) {
      console.warn("display-logs-tabs-datatable: initialise failed", err)
      return
    }

    const saved = this.savedSearch[href]
    const q = saved != null && saved !== undefined ? saved : ""

    window.setTimeout(() => {
      if (!activeTable || !$.fn.DataTable.isDataTable(activeTable)) return
      try {
        const api = $(activeTable).DataTable()
        api.search(q).draw(false)
        const $inp = $(api.table().container()).find(".dataTables_filter input").first()
        if ($inp.length) $inp.val(q)
        api.columns.adjust()
        this.wireSearch(activeTable)
      } catch (err) {
        console.warn("display-logs-tabs-datatable: post-init failed", err)
      }
    }, 0)
  }
}
